/**
 * Cart discount-removal fix.
 *
 * Broadcast only binds the discount row's remove (x) button when the cart ALSO has a
 * discount-code input block: CartItems sets `hasDiscountBlock` from the presence of
 * [data-apply-discount] and `bindDiscountEventListeners()` early-returns without it
 * (see theme.dev.js ~1263/1493). Duavaa's cart has no discount input block - codes like
 * DUA5 are applied via /discount/ URLs from ads and announcements - so the theme renders
 * the x on the discount row but never wires it. Clicking it did nothing.
 *
 * This shim adds a delegated click handler for [data-remove-discount] that only acts
 * when the theme's own binding is absent (no [data-apply-discount] on the page). It
 * removes that row's code, keeps any other applied codes, and updates the cart the same
 * way the theme does (POST {discount} to routes.cart_update_url), then reloads so all
 * totals re-render server-side.
 *
 * Verified live on the cart page (US, DUA5) before shipping.
 */
(function () {
  'use strict';

  var busy = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-discount]');
    if (!btn) return;

    // Theme binds its own handler when the discount input block exists - defer to it.
    if (document.querySelector('[data-apply-discount]')) return;

    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;

    var row = btn.closest('[data-discount-body]');
    var removedCode = row ? row.getAttribute('data-discount-code') : '';

    // Keep every other applied code (rows are rendered per discount in cart-price.liquid).
    var remaining = [];
    var rows = document.querySelectorAll('[data-discount-body]');
    for (var i = 0; i < rows.length; i++) {
      var code = rows[i].getAttribute('data-discount-code');
      if (code && code !== removedCode && remaining.indexOf(code) === -1) {
        remaining.push(code);
      }
    }

    if (row) row.style.opacity = '0.4';

    var route =
      (window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update';

    fetch(route, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: remaining.join(',') })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        // Reload so subtotal, discount rows and any offer displays re-render from source.
        window.location.reload();
      })
      .catch(function () {
        busy = false;
        if (row) row.style.opacity = '';
      });
  }, true);
})();
